import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { HelmetProvider } from "react-helmet-async";
import SEO from "./componentes/SEO";
import { DarkModeProvider } from "./context/DarkModeContext";
import { LanguageProvider } from "./context/LanguageContext";


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
      <DarkModeProvider>
        <HelmetProvider>
          <LanguageProvider>
            <SEO />
            <App />
          </LanguageProvider>
        </HelmetProvider>
      </DarkModeProvider>
  </React.StrictMode>,
);
